import { get, post } from '@/utils/request'

const DOC_BASE_URL = '/cmp-doc/data-project-doc'

// 新增文档（返回文档 ID）
export const addDoc = (params: any, requestId: any): Promise<number> => {
  return post(`${DOC_BASE_URL}/add?requestId=${requestId}`, params, {}, 'document')
}

// 删除文档（返回是否成功）
export const removeDoc = (params: any, requestId?: string): Promise<boolean> => {
  return post(`${DOC_BASE_URL}/remove${requestId ? `?requestId=${requestId}` : ''}`, params, {}, 'document')
}

// 查询文档列表（返回文档列表）
export const getDocList = (params: any): Promise<any[]> => {
  return post(`${DOC_BASE_URL}/list`, params, {}, 'document')
}

// 导出文档（返回导出文件地址列表）
// 响应：
// {
// 	"exportKey": "",
// 	"fileName": ""
// }
export const exportDoc = (params: any): Promise<any> => {
  return post(`${DOC_BASE_URL}/export`, params, {}, 'document')
}

// 导出文档任务查询 ，返回格式：
// {
// 	"exportKey": "",
// 	"fileName": "",
// 	"downloadUrl": "",
// 	"status": 0,
// 	"failReason": ""
// }
export const getExportDocTask = (params: any): Promise<any> => {
  return get(`${DOC_BASE_URL}/exportStatus`, params, {}, 'document')
}

// 引用文档（无返回值）
export const linkDoc = (params: any): Promise<void> => {
  return post(`${DOC_BASE_URL}/link`, params, {}, 'document')
}

// 修改文档
export const updateProjectDoc = (params: any, requestId): Promise<void> => {
  return post(`${DOC_BASE_URL}/modify?requestId=${requestId}`, params, {}, 'document')
}

// 添加模板文档
export const addDocByTemplate = (params: any, requestId?: string): Promise<void> => {
  return post(`${DOC_BASE_URL}/add-doc-by-template${requestId ? `?requestId=${requestId}` : ''}`, params, {}, 'document')
}


// 查询文档使用的字段域信息复制接口复制文档复制地址
export const listFieldByDoc = (params: any): Promise<any[]> => {
  return get(`${DOC_BASE_URL}/list-field-by-doc`, params, {}, 'document')
}


// 更新文档签署状态
// projectId  docId  signStatus 
export const updateSignStatus = (params: any): Promise<void> => {
  return post(`${DOC_BASE_URL}/update-sign-status`, params, {}, 'document')
}

// 引用文件夹
// {
//   "projectId": 0,
//   "sourceFolderIds": [],
//   "targetParentFolderId": 0
// }
export const linkCompileFolder = (params: any, requestId: string): Promise<void> => {
  return post(`/cmp-doc/data-project-folder/copy?requestId=${requestId}`, params, {}, 'document')
}
// 引用文件
// {
//   "projectId": 0,
//   "docId": 0,
//   "parentId": 0
// }
export const linkCompileDocument = (params: any, requestId: string): Promise<void> => {
  return post(`/cmp-doc/data-project-doc/link?requestId=${requestId}`, params, {}, 'document')
}
